import React from 'react';

import {
  Pressable,
  View
} from 'react-native';

import * as _cr from './_cr';
import { useNgnz } from './_csNgn';
import * as _gv from './_gv';
import * as _hm from './_hm';
import * as _hmDTM from './_hmDTM';
import * as _ht from './_ht';

import * as icm from './icm';

//import * as _cmODT from './_cmODT';

import { a } from './_cmABT';

export type tBoxCz = {
  boxAbtz?: _ht.dz, // attribute
  boxStlz?: _ht.dz, // style
  boxPtyz?: _ht.dz, // property
  pslPtyz?: _ht.dz, // pressable
  pslStlz?: _ht.dz, // pressable
  boxClds?: _ht.ls, // children
}

const $grtAbtz = (pz?: {
  type?: _ht.s,
}) => {
  switch (pz?.type) {
    default:
      return {
        boxStlz: a('fd/css'),
        boxPtyz: {},
        boxPslz: {},
      }
  }
};

export const N = React.memo((pz: tBoxCz) => {

  const _abtz = $grtAbtz(pz.boxAbtz)

  const _sNgnz = useNgnz();

  let _o = (
    _cr.c(View, {
      ... _abtz.boxPtyz,
      ... pz.boxPtyz,
      style: {
        ... _abtz.boxStlz,
        ... pz.boxStlz,
      },
    }, 
      pz.boxClds
    )
  );

  if (pz.pslPtyz) {
    _o = (
      _cr.c(Pressable, { // 別途 dw を指定用
        ...pz.pslPtyz,
        style: {
          ... pz.pslStlz, // 改行されない場合は dw/f を設定
        },
        onPress: 
          pz.pslPtyz?.onPrs ?
          async () => {
            const _gUserz = _gv.useUserz();
            const _drc = _hmDTM.getDrcMnt(_gUserz.crt.ornDtm)
            if ( _drc > 1440 ) {
              await _gUserz.saveAsync({
                ornDtm: '',
                _20rz: {},
                _30rz: {},
                _10rz: {},
              })
              if (_sNgnz.getPageName() != 'icvLgnM10Rz') {
                _sNgnz.setPageName('icvLgnM10Rz');
              }
            }
            else {
              await _gUserz.saveAsync({
                ornDtm: _hmDTM.getNow()
              });
              pz.pslPtyz?.onPrs();
            }
          }
          : undefined,
      }, 
        _o
      )
    );
  }

  return _o;

});

/*
export const P = React.memo((pz: tBoxCz) => {

  const _o = (
    _cr.c(Pressable, { // 別途 dw を指定用
      ...pz.pslPtyz,
      style: {
        ... pz.pslStlz, // 改行されない場合は dw/f を設定
      },
      onPress: 
        pz.pslPtyz?.onPrs ?
        async () => {
          await _cmODT.setAsync();
          pz.pslPtyz?.onPrs();
        }
        : undefined,
    }, 
      _cr.c(N, pz)
    )
  );

  return _o;

});
*/